/**
 * @generated SignedSource<<d21ee8dc5aa2c565a13c4e936f53c411>>
 * @relayHash c213325523fa8093ca0c60c9ebfa9aef
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d573c6a12c5fe8fdf2fa662d95c209d47ee53599c80980cea146a8c377e17c70

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiFeaturesPlansSettingsQuery } from './uiFeaturesPlansSettingsQuery.graphql';

const node: PreloadableConcreteRequest<uiFeaturesPlansSettingsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "d573c6a12c5fe8fdf2fa662d95c209d47ee53599c80980cea146a8c377e17c70",
    "metadata": {},
    "name": "uiFeaturesPlansSettingsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
